export class ReasonChangeTrafficActionsRequest {
  public reasonId: number;
  public eventId: number;

  constructor(eventId: number, reasonId: number) {
    this.eventId = eventId;
    this.reasonId = reasonId;
  }
}
